/* PACKAGES */
import PhoneInput from "react-phone-number-input";

/* ICONS */
import { FaRegCircleCheck } from "react-icons/fa6";
import { AiOutlineExclamationCircle } from "react-icons/ai";

/* HELPER FUNCTION */
const formatPhone = (value) => {
  const digits = value.replace(/\D/g, "").slice(0, 10);

  if (digits.length === 0) return "";

  if (digits.length < 4) return `(${digits}`;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

const FormInput = (props) => {
  const handleChange = (e) => {
    let value = e.target.value;

    if (props.type === "phone") {
      value = formatPhone(value);
    }

    props.onChange({
      ...e,
      target: {
        ...e.target,
        value,
      },
    });
  };

  return (
    <div className="form-group">
      <div
        className={`w-full px-4 py-3 bg-white border ${
          props.errorHandler ? "border-red-500" : "border-greyBorder"
        } rounded-md relative`}
      >
        <input
          type={props.type === "phone" ? "text" : props.type}
          name={props.name}
          id={props.id}
          placeholder={props.placeholder}
          className="w-full block font-source font-semibold placeholder:font-source placeholder:font-normal text-sm text-black p-0 focus:outline-none"
          value={props.value}
          onChange={handleChange}
          inputMode={props.type === "phone" ? "numeric" : undefined}
        />

        {/* Error icon */}
        {props.errorHandler && props.type !== "password" && (
          <div className="absolute top-3 right-3">
            <AiOutlineExclamationCircle className="w-5 h-5 text-red-500" />
          </div>
        )}

        {/* Success icon for normal fields */}
        {props.type !== "email" &&
          props.type !== "password" &&
          props.type !== "phone" &&
          props.value?.length >= 2 && (
            <div className="absolute top-3 right-3">
              <FaRegCircleCheck className="w-5 h-5 text-green-500" />
            </div>
          )}

        {/* Success icon for email */}
        {props.type === "email" && props.value?.includes("@") && (
          <div className="absolute top-3 right-3">
            <FaRegCircleCheck className="w-5 h-5 text-green-500" />
          </div>
        )}

        {/* Success icon for phone */}
        {props.type === "phone" &&
          props.value?.replace(/\D/g, "").length === 10 && (
            <div className="absolute top-3 right-3">
              <FaRegCircleCheck className="w-5 h-5 text-green-500" />
            </div>
          )}
      </div>
    </div>
  );
};

const PhoneInputField = (props) => {
  return (
    <div className="relative">
      <PhoneInput
        placeholder="Phone number"
        defaultCountry="IN"
        className={`phone-input font-source font-semibold ${
          props.errorHandler && "error"
        }`}
        id="phone"
        name="phone"
        value={props.value}
        onChange={props.onChange}
      />

      {props.errorHandler && (
        <div className="absolute top-3 right-3">
          <AiOutlineExclamationCircle className="w-5 h-5 text-red-500" />
        </div>
      )}

      {props.value?.length === 10 && (
        <div className="absolute top-3 right-3">
          <FaRegCircleCheck className="w-5 h-5 text-green-500" />
        </div>
      )}
    </div>
  );
};

const CouponCodeField = (props) => {
  return (
    <div className="form-group">
      <div
        className={`w-full px-4 py-3 bg-white border ${
          props.errorHandler ? "border-red-500" : "border-greyBorder"
        } rounded-md relative`}
      >
        <input
          type={props.type}
          name={props.name}
          id={props.id}
          placeholder={props.placeholder}
          className="w-full block font-source font-semibold placeholder:font-source placeholder:font-normal text-sm text-black p-0 focus:outline-none"
          value={props.value}
          onChange={props.onChange}
        />

        {props.errorHandler && (
          <div className="absolute top-3 right-3">
            <AiOutlineExclamationCircle className="w-5 h-5 text-red-500" />
          </div>
        )}

        {props.value?.length >= 2 && (
          <div className="absolute top-3 right-3">
            <FaRegCircleCheck className="w-5 h-5 text-green-500" />
          </div>
        )}
      </div>
    </div>
  );
};

const FormTextarea = (props) => {
  return (
    <div className="form-group">
      <div
        className={`w-full px-4 py-3 bg-white border ${
          props.errorHandler ? "border-red-500" : "border-greyBorder"
        } rounded-md relative`}
      >
        <textarea
          rows={props.rows}
          name={props.name}
          id={props.id}
          placeholder={props.placeholder}
          className="w-full block font-source font-semibold placeholder:font-source placeholder:font-normal text-sm text-black p-0 focus:outline-none"
          value={props.value}
          onChange={props.onChange}
        />

        {props.errorHandler && props.type !== "password" && (
          <div className="absolute top-3 right-3">
            <AiOutlineExclamationCircle className="w-5 h-5 text-red-500" />
          </div>
        )}

        {props.type !== "email" &&
          props.type !== "password" &&
          props.value.length >= 2 && (
            <div className="absolute top-3 right-3">
              <FaRegCircleCheck className="w-5 h-5 text-green-500" />
            </div>
          )}

        {props.type === "email" && props.value.includes("@") && (
          <div className="absolute top-3 right-3">
            <FaRegCircleCheck className="w-5 h-5 text-green-500" />
          </div>
        )}
      </div>
    </div>
  );
};

export { FormInput, PhoneInputField, CouponCodeField, FormTextarea };
